function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  font-family: o-HelveticaNeue, Arial, sans-serif;\n  font-weight: 700;\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  max-width: ", ";\n  text-decoration: none;\n  white-space: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  cursor: ", ";\n  pointer-events: ", ";\n  padding: ", ";\n\n  svg {\n    margin-left: ", ";\n    margin-right: ", ";\n\n    path {\n      fill: ", ";\n    }\n  }\n\n  :hover,\n  :focus {\n    text-decoration: ", ";\n    text-decoration-color: ", ";\n  }\n\n  :active {\n    color: ", ";\n  }\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ArrowNext from '../Icons/ArrowNext';
import ArrowPrevious from '../Icons/ArrowPrevious';
import ArrowUp from '../Icons/ArrowUp';
import ArrowDown from '../Icons/ArrowDown';
import { px2rem, padding } from '../Utils/helpers';
import { colors, text, arrowLink } from '../../styles/variables';
var StyledLink = styled('a')(_templateObject(), function (_ref) {
  var background = _ref.background;
  return colors[background];
}, function (_ref2) {
  var background = _ref2.background,
      disabled = _ref2.disabled;

  switch (background) {
    case 'white':
      return !disabled ? colors.black : colors.grey4;

    case 'black':
      return !disabled ? colors.white : colors.grey3;

    default:
      return !disabled ? colors.black : colors.grey3;
  }
}, function (_ref3) {
  var mini = _ref3.mini;
  return !mini ? px2rem(text.standard.large.fontSize) : px2rem(text.standard.medium.fontSize);
}, function (_ref4) {
  var mini = _ref4.mini;
  return !mini ? px2rem(text.standard.large.lineHeight) : px2rem(text.standard.medium.lineHeight);
}, px2rem(arrowLink.maxWidth), function (_ref5) {
  var variant = _ref5.variant;
  return variant === 'previous' ? 'nowrap' : undefined;
}, function (_ref6) {
  var variant = _ref6.variant;
  return variant === 'previous' ? 'hidden' : undefined;
}, function (_ref7) {
  var variant = _ref7.variant;
  return variant === 'previous' ? 'ellipsis' : undefined;
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return !disabled ? 'pointer' : 'default';
}, function (_ref9) {
  var disabled = _ref9.disabled;
  return disabled ? 'none' : undefined;
}, function (_ref10) {
  var mini = _ref10.mini;
  return !mini ? padding(arrowLink.standard) : padding(arrowLink.mini);
}, function (_ref11) {
  var variant = _ref11.variant,
      mini = _ref11.mini;
  return variant !== 'previous' && (!mini ? px2rem(arrowLink.standard.icon.margin) : px2rem(arrowLink.mini.icon.margin));
}, function (_ref12) {
  var variant = _ref12.variant,
      mini = _ref12.mini;
  return variant === 'previous' && (!mini ? px2rem(arrowLink.standard.icon.margin) : px2rem(arrowLink.mini.icon.margin));
}, function (_ref13) {
  var background = _ref13.background,
      disabled = _ref13.disabled;

  switch (background) {
    case 'white':
      return !disabled ? colors.primaryDark : colors.grey4;

    case 'black':
      return !disabled ? colors.primary : colors.grey3;

    default:
      return !disabled ? colors.black : colors.grey3;
  }
}, function (_ref14) {
  var disabled = _ref14.disabled;
  return !disabled ? 'underline' : undefined;
}, function (_ref15) {
  var background = _ref15.background;

  switch (background) {
    case 'white':
      return colors.primaryDark;

    case 'black':
      return colors.primary;

    default:
      return colors.black;
  }
}, function (_ref16) {
  var background = _ref16.background;

  switch (background) {
    case 'white':
      return colors.primaryDark;

    case 'black':
      return colors.primary;

    default:
      return colors.black;
  }
}); // https://app.zeplin.io/project/5c3323cb6124c7af1c4ce96e/screen/5c333ccb46bce344084adc33

function ArrowLink(props) {
  var children = props.children,
      variant = props.variant,
      disabled = props.disabled,
      mini = props.mini,
      rest = _objectWithoutPropertiesLoose(props, ["children", "variant", "disabled", "mini"]);

  var icon;

  switch (variant) {
    case 'previous':
      icon = ArrowPrevious;
      break;

    case 'up':
      icon = ArrowUp;
      break;

    case 'down':
      icon = ArrowDown;
      break;

    case 'next':
    default:
      icon = ArrowNext;
  }

  return React.createElement(StyledLink, _extends({
    variant: variant,
    mini: mini,
    disabled: disabled,
    tabIndex: disabled ? -1 : undefined
  }, rest), variant === 'previous' && React.createElement(icon, {
    size: !mini ? arrowLink.standard.icon.size : arrowLink.mini.icon.size
  }), children, variant !== 'previous' && React.createElement(icon, {
    size: !mini ? arrowLink.standard.icon.size : arrowLink.mini.icon.size
  }));
}

ArrowLink.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['next', 'previous', 'up', 'down']),
  href: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  background: PropTypes.oneOf(['white', 'black', 'dimmedSuccess', 'dimmedError', 'dimmedInfo', 'dimmedAlert', 'grey2']),
  mini: PropTypes.bool
} : {};
ArrowLink.defaultProps = {
  variant: 'next',
  disabled: false,
  background: 'white',
  mini: false
};
export default ArrowLink;